/**
 * @deprecated This file is deprecated. Use CoreIcon from @vitvio/design-system instead.
 * New icons should be added as SVG files in libs/design-system/src/lib/icons/
 */
import type { IconProps } from '@vitvio/design-system';
import { Icon, useTheme } from '@vitvio/design-system';

export type MergedIconProps = IconProps & {
  color?: string;
  outline?: boolean;
  outlineColor?: string;
};

export const VitVioIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 36 36" fill={'none'} {...props}>
      <path
        d="M33.6466 11.0304L27.6493 8.49019C27.1415 8.27491 26.8065 7.76901 26.8065 7.22006V2.31177C26.8065 0.535741 24.883 -0.572927 23.3378 0.309704L9.58192 8.15651L2.12587 12.4297C1.40187 12.8388 0.958832 13.603 0.958832 14.4318V21.579C0.958832 22.4078 1.40187 23.172 2.12587 23.581L9.58192 27.8435L23.327 35.6903C24.8722 36.5729 26.7957 35.4643 26.7957 33.6882V28.7907C26.7957 28.231 27.1307 27.7358 27.6385 27.5206L33.6358 24.9696C34.4895 24.6036 35.0406 23.7748 35.0406 22.8491V13.1724C35.0622 12.236 34.5003 11.3964 33.6466 11.0304ZM9.19291 19.254C8.15554 18.7481 8.14474 17.2734 9.19291 16.7675L20.3446 11.3426L24.6885 9.23289C25.6178 8.78081 26.6876 9.45893 26.6876 10.4815V25.5293C26.6876 26.5518 25.607 27.2192 24.6885 26.7779L20.3446 24.6682L9.19291 19.254Z"
        fill={props.color ? props.color : getColor('fg')}
      />
    </Icon>
  );
};

export const HomeIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 24 24" fill={'none'} {...props}>
      <path
        d="M9.02 2.84004L3.63 7.04004C2.73 7.74004 2 9.23004 2 10.36V17.77C2 20.09 3.89 21.99 6.21 21.99H17.79C20.11 21.99 22 20.09 22 17.78V10.5C22 9.29004 21.19 7.74004 20.2 7.05004L14.02 2.72004C12.62 1.74004 10.37 1.79004 9.02 2.84004Z"
        stroke={props.color ? props.color : getColor('fg')}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        stroke={props.color ? props.color : getColor('fg')}
        d="M12 17.99V14.99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export const KeyboardOpenIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 24 24" fill={'none'} {...props}>
      <path
        d="M7.25998 2H16.73C17.38 2 17.96 2.02003 18.48 2.09003C21.25 2.40003 22 3.70001 22 7.26001V13.58C22 17.14 21.25 18.44 18.48 18.75C17.96 18.82 17.39 18.84 16.73 18.84H7.25998C6.60998 18.84 6.02998 18.82 5.50998 18.75C2.73998 18.44 1.98999 17.14 1.98999 13.58V7.26001C1.98999 3.70001 2.73998 2.40003 5.50998 2.09003C6.02998 2.02003 6.60998 2 7.25998 2Z"
        stroke={props.color ? props.color : getColor('fg')}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.58 8.32007H17.2599"
        stroke={props.color ? props.color : getColor('fg')}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.73999 14.11H6.75998H17.27"
        stroke={props.color ? props.color : getColor('fg')}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 22H17"
        stroke={props.color ? props.color : getColor('fg')}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.1947 8.30005H7.20368"
        stroke={props.color ? props.color : getColor('fg')}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4945 8.30005H10.5035"
        stroke={props.color ? props.color : getColor('fg')}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export const TaskSquareIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 24 24" fill={'none'} {...props}>
      <path
        d="M12.37 8.88H17.62"
        stroke={props.color ? props.color : getColor('fg')}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.38 8.88L7.13 9.63L9.38 7.38"
        stroke={props.color ? props.color : getColor('fg')}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.37 15.88H17.62"
        stroke={props.color ? props.color : getColor('fg')}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.38 15.88L7.13 16.63L9.38 14.38"
        stroke={props.color ? props.color : getColor('fg')}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke={props.color ? props.color : getColor('fg')}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export const AddPlusIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 24 24" fill={'none'} {...props}>
      <path d="M8 12H16" stroke={getColor('fg')} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 16V8" stroke={getColor('fg')} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke={getColor('fg')}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export const SettingsIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 24 24" fill={'none'} {...props}>
      <path
        d="M3 9.10998V14.88C3 17 3 17 5 18.35L10.5 21.53C11.33 22.01 12.68 22.01 13.5 21.53L19 18.35C21 17 21 17 21 14.89V9.10998C21 6.99998 21 6.99999 19 5.64999L13.5 2.46999C12.68 1.98999 11.33 1.98999 10.5 2.46999L5 5.64999C3 6.99999 3 6.99998 3 9.10998Z"
        stroke={getColor('fg')}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        stroke={getColor('fg')}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export const DotIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 200 200" {...props}>
      <path
        fill="currentColor"
        d="M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0"
        stroke={getColor('fg.inverted')}
        strokeWidth="20"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export const TickCircleIconNoBorder = (props: MergedIconProps) => (
  <Icon viewBox="0 0 12 12" {...props}>
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.3 5.9L3.225 4.825C3.13333 4.73333 3.01667 4.6875 2.875 4.6875C2.73333 4.6875 2.61667 4.73333 2.525 4.825C2.43333 4.91667 2.3875 5.03333 2.3875 5.175C2.3875 5.31667 2.43333 5.43333 2.525 5.525L3.95 6.95C4.05 7.05 4.16667 7.1 4.3 7.1C4.43333 7.1 4.55 7.05 4.65 6.95L7.475 4.125C7.56667 4.03333 7.6125 3.91667 7.6125 3.775C7.6125 3.63333 7.56667 3.51667 7.475 3.425C7.38333 3.33333 7.26667 3.2875 7.125 3.2875C6.98333 3.2875 6.86667 3.33333 6.775 3.425L4.3 5.9ZM5 10C4.30833 10 3.65833 9.86875 3.05 9.60625C2.44167 9.34375 1.9125 8.9875 1.4625 8.5375C1.0125 8.0875 0.65625 7.55833 0.39375 6.95C0.13125 6.34167 0 5.69167 0 5C0 4.30833 0.13125 3.65833 0.39375 3.05C0.65625 2.44167 1.0125 1.9125 1.4625 1.4625C1.9125 1.0125 2.44167 0.65625 3.05 0.39375C3.65833 0.13125 4.30833 0 5 0C5.69167 0 6.34167 0.13125 6.95 0.39375C7.55833 0.65625 8.0875 1.0125 8.5375 1.4625C8.9875 1.9125 9.34375 2.44167 9.60625 3.05C9.86875 3.65833 10 4.30833 10 5C10 5.69167 9.86875 6.34167 9.60625 6.95C9.34375 7.55833 8.9875 8.0875 8.5375 8.5375C8.0875 8.9875 7.55833 9.34375 6.95 9.60625C6.34167 9.86875 5.69167 10 5 10Z"
        fill="#14B6DB"
      />
    </svg>
  </Icon>
);

/**
 * @deprecated Use CoreIcon from @vitvio/design-system instead
 */
export const InfoCircleIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      {props.outline && <circle cx="12" cy="12" r="12" fill={getColor('fg.inverted')} />}

      <path
        d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM11.25 8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75C11.59 13.75 11.25 13.41 11.25 13V8ZM12.92 16.38C12.87 16.51 12.8 16.61 12.71 16.71C12.61 16.8 12.5 16.87 12.38 16.92C12.26 16.97 12.13 17 12 17C11.87 17 11.74 16.97 11.62 16.92C11.5 16.87 11.39 16.8 11.29 16.71C11.2 16.61 11.13 16.51 11.08 16.38C11.03 16.26 11 16.13 11 16C11 15.87 11.03 15.74 11.08 15.62C11.13 15.5 11.2 15.39 11.29 15.29C11.39 15.2 11.5 15.13 11.62 15.08C11.86 14.98 12.14 14.98 12.38 15.08C12.5 15.13 12.61 15.2 12.71 15.29C12.8 15.39 12.87 15.5 12.92 15.62C12.97 15.74 13 15.87 13 16C13 16.13 12.97 16.26 12.92 16.38Z"
        fill="currentColor"
      />
    </Icon>
  );
};

/**
 * @deprecated Use CoreIcon from @vitvio/design-system instead
 */
export const FlashCircleIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      {props.outline && <circle cx="12" cy="12" r="12" fill={getColor('fg.inverted')} />}

      <path
        d="M11.97 2C6.44997 2 1.96997 6.48 1.96997 12C1.96997 17.52 6.44997 22 11.97 22C17.49 22 21.97 17.52 21.97 12C21.97 6.48 17.5 2 11.97 2ZM15.72 12.35L12 16.58L11.56 17.08C10.95 17.77 10.45 17.59 10.45 16.66V12.7H8.74997C7.97997 12.7 7.76997 12.23 8.27997 11.65L12 7.42L12.44 6.92C13.05 6.23 13.55 6.41 13.55 7.34V11.3H15.25C16.02 11.3 16.23 11.77 15.72 12.35Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export const SearchIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 24 24" fill={'transparent'} {...props}>
      <path
        d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
        stroke={getColor('fg')}
        strokeWidth="2.0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M22 22L20 20" stroke={getColor('fg')} strokeWidth="2.0" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
  );
};

export const NotificationIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 24 24" fill={getColor('fg.inverted')} {...props}>
      <path
        d="M12.02 2.91003C8.70997 2.91003 6.01997 5.60003 6.01997 8.91003V11.8C6.01997 12.41 5.75997 13.34 5.44997 13.86L4.29997 15.77C3.58997 16.95 4.07997 18.26 5.37997 18.7C9.68997 20.14 14.34 20.14 18.65 18.7C19.86 18.3 20.39 16.87 19.73 15.77L18.58 13.86C18.28 13.34 18.02 12.41 18.02 11.8V8.91003C18.02 5.61003 15.32 2.91003 12.02 2.91003Z"
        stroke={getColor('fg')}
        strokeWidth="2.0"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M13.87 3.19994C13.56 3.10994 13.24 3.03994 12.91 2.99994C11.95 2.87994 11.03 2.94994 10.17 3.19994C10.46 2.45994 11.18 1.93994 12.02 1.93994C12.86 1.93994 13.58 2.45994 13.87 3.19994Z"
        stroke={getColor('fg')}
        strokeWidth="2.0"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.02 19.0601C15.02 20.7101 13.67 22.0601 12.02 22.0601C11.2 22.0601 10.44 21.7201 9.90002 21.1801C9.36002 20.6401 9.02002 19.8801 9.02002 19.0601"
        stroke={getColor('fg')}
        strokeWidth="2.0"
        strokeMiterlimit="10"
      />
    </Icon>
  );
};

export const MessageIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 24 24" fill={getColor('fg.inverted')} {...props}>
      <path
        d="M8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H16C20 2 22 4 22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19Z"
        stroke={getColor('fg')}
        strokeWidth="2.0"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9965 11H16.0054"
        stroke={getColor('fg')}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9955 11H12.0045"
        stroke={getColor('fg')}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99451 11H8.00349"
        stroke={getColor('fg')}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export const SettingIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 24 24" fill={getColor('fg.inverted')} {...props}>
      <path
        d="M22 6.5H16"
        stroke={getColor('fg')}
        strokeWidth="2.0"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6.5H2"
        stroke={getColor('fg')}
        strokeWidth="2.0"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10C11.933 10 13.5 8.433 13.5 6.5C13.5 4.567 11.933 3 10 3C8.067 3 6.5 4.567 6.5 6.5C6.5 8.433 8.067 10 10 10Z"
        stroke={getColor('fg')}
        strokeWidth="2.0"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 17.5H18"
        stroke={getColor('fg')}
        strokeWidth="2.0"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 17.5H2"
        stroke={getColor('fg')}
        strokeWidth="2.0"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 21C15.933 21 17.5 19.433 17.5 17.5C17.5 15.567 15.933 14 14 14C12.067 14 10.5 15.567 10.5 17.5C10.5 19.433 12.067 21 14 21Z"
        stroke={getColor('fg')}
        strokeWidth="2.0"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

/**
 * @deprecated Use `<CoreIcon icon="schedule" />` from `@vitvio/design-system` instead.
 */
export const ClockIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 24 24" fill={'transparent'} {...props}>
      <path
        d="M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12Z"
        stroke={props.outlineColor ? props.outlineColor : getColor('fg.inverted')}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.71 15.18L12.61 13.33C12.07 13.01 11.63 12.24 11.63 11.61V7.51001"
        stroke={props.color ? props.color : getColor('fg.inverted')}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export const PencilUnderlineIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 24 24" fill={'transparent'} strokeWidth={'1.5'} {...props}>
      <path
        d="M13.26 3.59997L5.04997 12.29C4.73997 12.62 4.43997 13.27 4.37997 13.72L4.00997 16.96C3.87997 18.13 4.71997 18.93 5.87997 18.73L9.09997 18.18C9.54997 18.1 10.18 17.77 10.49 17.43L18.7 8.73997C20.12 7.23997 20.76 5.52997 18.55 3.43997C16.35 1.36997 14.68 2.09997 13.26 3.59997Z"
        stroke={getColor('fg')}
        strokeWidth={props.strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.89 5.05005C12.32 7.81005 14.56 9.92005 17.34 10.2"
        stroke={getColor('fg')}
        strokeWidth={props.strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 22H21"
        stroke={getColor('fg')}
        strokeWidth={props.strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export const InvertedInfoCircleIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 24 24" fill={'transparent'} {...props}>
      <path
        d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
        stroke={getColor('fg')}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9983 17L11.9983 12"
        stroke={getColor('fg')}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0037 9L11.9947 9"
        stroke={getColor('fg')}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export const TimerIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 24 24" fill={'transparent'} {...props}>
      <path
        d="M20.75 13.25C20.75 18.08 16.83 22 12 22C7.17 22 3.25 18.08 3.25 13.25C3.25 8.42 7.17 4.5 12 4.5C16.83 4.5 20.75 8.42 20.75 13.25Z"
        stroke={props?.stroke ? String(props.stroke) : getColor('fg')}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8V13"
        stroke={props?.stroke ? String(props.stroke) : getColor('fg')}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 2H15"
        stroke={props?.stroke ? String(props.stroke) : getColor('fg')}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export const TrashIcon = (props: MergedIconProps) => {
  return (
    <Icon viewBox="0 0 24 24" fill={'transparent'} {...props}>
      <path
        d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.85 9.14001L18.2 19.21C18.09 20.78 18 22 15.21 22H8.79002C6.00002 22 5.91002 20.78 5.80002 19.21L5.15002 9.14001"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.33 16.5H13.66"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9.5 12.5H14.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
  );
};

export const IdleTimerIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 12 12" fill={'transparent'} {...props}>
      <path
        d="M3.29374 2.40438C2.2043 3.22565 1.5 4.53058 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5V3.5"
        stroke={getColor('fg')}
        strokeLinecap="round"
        strokeWidth=".75"
      />
      <path d="M6 6.5L4 4.5" stroke={getColor('fg')} strokeLinecap="round" strokeWidth=".75" />
    </Icon>
  );
};
export const IndicatorIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 40 40" fill={'none'} color={getColor('blue.500')} {...props}>
      <rect width="40" height="40" rx="20" fill={getColor('fg.inverted')} />
      <path
        d="M19.975 11.6667C15.375 11.6667 11.6417 15.4001 11.6417 20.0001C11.6417 24.6001 15.375 28.3334 19.975 28.3334C24.575 28.3334 28.3083 24.6001 28.3083 20.0001C28.3083 15.4001 24.5833 11.6667 19.975 11.6667Z"
        fill="currentColor"
      />
      <path
        d="M22.2243 21.6822L20.5399 20.0001H19.4101L17.7257 21.6822C17.2546 22.1497 17.1004 22.8692 17.3297 23.5201C17.559 24.1663 18.1176 24.5834 18.7472 24.5834H21.2028C21.8365 24.5834 22.391 24.1663 22.6203 23.5201C22.8496 22.8692 22.6954 22.1497 22.2243 21.6822Z"
        fill={getColor('fg.inverted')}
      />
      <path
        d="M22.623 16.4801C22.3936 15.8338 21.8348 15.4167 21.2051 15.4167H18.7448C18.1151 15.4167 17.5563 15.8338 17.3269 16.4801C17.1017 17.1309 17.256 17.8505 17.7273 18.318L19.412 20.0001H20.5421L22.2268 18.318C22.6939 17.8505 22.8482 17.1309 22.623 16.4801Z"
        fill={getColor('fg.inverted')}
      />
    </Icon>
  );
};

export const IndicatorPendingIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 40 40" fill={'none'} color={getColor('blue.500')} {...props}>
      <rect width="40" height="40" rx="20" fill="#E8EDF1" />
      <path
        d="M20.0004 13.875C16.0171 13.875 12.7754 17.1167 12.7754 21.1C12.7754 25.0833 16.0171 28.3333 20.0004 28.3333C23.9837 28.3333 27.2254 25.0917 27.2254 21.1083C27.2254 17.125 23.9837 13.875 20.0004 13.875ZM20.6254 20.8333C20.6254 21.175 20.3421 21.4583 20.0004 21.4583C19.6587 21.4583 19.3754 21.175 19.3754 20.8333V16.6667C19.3754 16.325 19.6587 16.0417 20.0004 16.0417C20.3421 16.0417 20.6254 16.325 20.6254 16.6667V20.8333Z"
        fill="#6F7275"
      />
      <path
        d="M22.408 12.8751H17.5914C17.258 12.8751 16.9914 12.6084 16.9914 12.2751C16.9914 11.9417 17.258 11.6667 17.5914 11.6667H22.408C22.7414 11.6667 23.008 11.9334 23.008 12.2667C23.008 12.6001 22.7414 12.8751 22.408 12.8751Z"
        fill="#6F7275"
      />
    </Icon>
  );
};

export const IndicatorCompletedIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 40 40" fill={'none'} {...props}>
      <rect y="0.5" width="40" height="40" rx="20" fill={getColor('fg.inverted')} />
      <path
        d="M20 12.1666C15.4083 12.1666 11.6667 15.9083 11.6667 20.5C11.6667 25.0916 15.4083 28.8333 20 28.8333C24.5917 28.8333 28.3333 25.0916 28.3333 20.5C28.3333 15.9083 24.5917 12.1666 20 12.1666ZM23.9833 18.5833L19.2583 23.3083C19.1417 23.425 18.9833 23.4916 18.8167 23.4916C18.65 23.4916 18.4917 23.425 18.375 23.3083L16.0167 20.95C15.775 20.7083 15.775 20.3083 16.0167 20.0666C16.2583 19.825 16.6583 19.825 16.9 20.0666L18.8167 21.9833L23.1 17.7C23.3417 17.4583 23.7417 17.4583 23.9833 17.7C24.225 17.9416 24.225 18.3333 23.9833 18.5833Z"
        fill={getColor('bg.accent')}
      />
    </Icon>
  );
};

export const CalendarDotIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 16 16" fill={'none'} {...props}>
      <path
        d="M9.66667 12.0002C9.2 12.0002 8.80556 11.8391 8.48333 11.5168C8.16111 11.1946 8 10.8002 8 10.3335C8 9.86683 8.16111 9.47239 8.48333 9.15016C8.80556 8.82794 9.2 8.66683 9.66667 8.66683C10.1333 8.66683 10.5278 8.82794 10.85 9.15016C11.1722 9.47239 11.3333 9.86683 11.3333 10.3335C11.3333 10.8002 11.1722 11.1946 10.85 11.5168C10.5278 11.8391 10.1333 12.0002 9.66667 12.0002ZM3.33333 14.6668C2.96667 14.6668 2.65278 14.5363 2.39167 14.2752C2.13056 14.0141 2 13.7002 2 13.3335V4.00016C2 3.6335 2.13056 3.31961 2.39167 3.0585C2.65278 2.79739 2.96667 2.66683 3.33333 2.66683H4V2.00016C4 1.81127 4.06389 1.65294 4.19167 1.52516C4.31944 1.39738 4.47778 1.3335 4.66667 1.3335C4.85556 1.3335 5.01389 1.39738 5.14167 1.52516C5.26944 1.65294 5.33333 1.81127 5.33333 2.00016V2.66683H10.6667V2.00016C10.6667 1.81127 10.7306 1.65294 10.8583 1.52516C10.9861 1.39738 11.1444 1.3335 11.3333 1.3335C11.5222 1.3335 11.6806 1.39738 11.8083 1.52516C11.9361 1.65294 12 1.81127 12 2.00016V2.66683H12.6667C13.0333 2.66683 13.3472 2.79739 13.6083 3.0585C13.8694 3.31961 14 3.6335 14 4.00016V13.3335C14 13.7002 13.8694 14.0141 13.6083 14.2752C13.3472 14.5363 13.0333 14.6668 12.6667 14.6668H3.33333ZM3.33333 13.3335H12.6667V6.66683H3.33333V13.3335Z"
        fill={getColor('bg.accent')}
      />
    </Icon>
  );
};

export const HalfCircleIcon = (props: MergedIconProps) => {
  const { getColor } = useTheme();
  return (
    <Icon viewBox="0 0 16 16" {...props} color={getColor('bg.accent')}>
      {props.outline && <circle cx="12" cy="12" r="12" fill={getColor('fg.accent')} />}
      <rect width="16" height="16" rx="8" fill={getColor('fg.accent')} />
      <path
        d="M8 3C8.65661 3 9.30679 3.12933 9.91342 3.3806C10.52 3.63188 11.0712 4.00017 11.5355 4.46447C11.9998 4.92876 12.3681 5.47995 12.6194 6.08658C12.8707 6.69321 13 7.34339 13 8C13 8.65661 12.8707 9.30679 12.6194 9.91342C12.3681 10.52 11.9998 11.0712 11.5355 11.5355C11.0712 11.9998 10.52 12.3681 9.91342 12.6194C9.30679 12.8707 8.65661 13 8 13L8 8L8 3Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export const TimerIconBorderless = (props: MergedIconProps) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path
      d="M7.99973 3.1001C4.81306 3.1001 2.21973 5.69343 2.21973 8.8801C2.21973 12.0668 4.81306 14.6668 7.99973 14.6668C11.1864 14.6668 13.7797 12.0734 13.7797 8.88676C13.7797 5.7001 11.1864 3.1001 7.99973 3.1001ZM8.49973 8.66676C8.49973 8.9401 8.27306 9.16676 7.99973 9.16676C7.72639 9.16676 7.49973 8.9401 7.49973 8.66676V5.33343C7.49973 5.0601 7.72639 4.83343 7.99973 4.83343C8.27306 4.83343 8.49973 5.0601 8.49973 5.33343V8.66676Z"
      fill={'currentColor'}
    />
    <path
      d="M9.92708 2.29992H6.07375C5.80708 2.29992 5.59375 2.08659 5.59375 1.81992C5.59375 1.55325 5.80708 1.33325 6.07375 1.33325H9.92708C10.1937 1.33325 10.4071 1.54659 10.4071 1.81325C10.4071 2.07992 10.1937 2.29992 9.92708 2.29992Z"
      fill={'currentColor'}
    />
  </Icon>
);

export const ClockIconBorderless = (props: MergedIconProps) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path
      d="M7.99967 1.33325C4.32634 1.33325 1.33301 4.32659 1.33301 7.99992C1.33301 11.6733 4.32634 14.6666 7.99967 14.6666C11.673 14.6666 14.6663 11.6733 14.6663 7.99992C14.6663 4.32659 11.673 1.33325 7.99967 1.33325ZM10.8997 10.3799C10.8063 10.5399 10.6397 10.6266 10.4663 10.6266C10.3797 10.6266 10.293 10.6066 10.213 10.5533L8.14634 9.31992C7.63301 9.01325 7.25301 8.33992 7.25301 7.74659V5.01325C7.25301 4.73992 7.47967 4.51325 7.75301 4.51325C8.02634 4.51325 8.25301 4.73992 8.25301 5.01325V7.74659C8.25301 7.98659 8.45301 8.33992 8.65967 8.45992L10.7263 9.69325C10.9663 9.83325 11.0463 10.1399 10.8997 10.3799Z"
      fill={'currentColor'}
    />
  </Icon>
);

export const NotificationIconBorderless = (props: MergedIconProps) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path
      d="M12.8936 9.65992L12.227 8.55325C12.087 8.30659 11.9603 7.83992 11.9603 7.56659V5.87992C11.9603 4.31325 11.0403 2.95992 9.71362 2.32659C9.36695 1.71325 8.72695 1.33325 7.99362 1.33325C7.26695 1.33325 6.61362 1.72659 6.26695 2.34659C4.96695 2.99325 4.06695 4.33325 4.06695 5.87992V7.56659C4.06695 7.83992 3.94029 8.30659 3.80029 8.54659L3.12695 9.65992C2.86029 10.1066 2.80029 10.5999 2.96695 11.0533C3.12695 11.4999 3.50695 11.8466 4.00029 12.0133C5.29362 12.4533 6.65362 12.6666 8.01362 12.6666C9.37362 12.6666 10.7336 12.4533 12.027 12.0199C12.4936 11.8666 12.8536 11.5133 13.027 11.0533C13.2003 10.5933 13.1536 10.0866 12.8936 9.65992Z"
      fill="currentColor"
    />
    <path
      d="M9.88678 13.3399C9.60678 14.1133 8.86678 14.6666 8.00012 14.6666C7.47345 14.6666 6.95345 14.4533 6.58678 14.0733C6.37345 13.8733 6.21345 13.6066 6.12012 13.3333C6.20678 13.3466 6.29345 13.3533 6.38678 13.3666C6.54012 13.3866 6.70012 13.4066 6.86012 13.4199C7.24012 13.4533 7.62678 13.4733 8.01345 13.4733C8.39345 13.4733 8.77345 13.4533 9.14678 13.4199C9.28678 13.4066 9.42678 13.3999 9.56012 13.3799C9.66678 13.3666 9.77345 13.3533 9.88678 13.3399Z"
      fill="currentColor"
    />
  </Icon>
);

export const TimeLapseIcon = (props: MergedIconProps) => {
  return (
    <Icon viewBox="0 0 24 24" fill={'transparent'} {...props}>
      <path
        d="M12 18C13.6667 18 15.0833 17.4167 16.25 16.25C17.4167 15.0833 18 13.6667 18 12C18 10.55 17.5375 9.275 16.6125 8.175C15.6875 7.075 14.5167 6.38333 13.1 6.1C12.8 6.06667 12.5417 6.15 12.325 6.35C12.1083 6.55 12 6.8 12 7.1V12L8.55 15.45C8.33333 15.6667 8.23333 15.925 8.25 16.225C8.26667 16.525 8.39167 16.7667 8.625 16.95C9.10833 17.3333 9.64167 17.6042 10.225 17.7625C10.8083 17.9208 11.4 18 12 18ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export const ErrorPageIcon = (props: MergedIconProps) => (
  <Icon viewBox="0 0 145 144" fill={'none'} boxSize="144px" {...props}>
    <g transform="translate(40, 40)">
      <rect
        x="41.5237"
        y="20.0285"
        width="31.0197"
        height="31.0197"
        rx="2.71423"
        transform="rotate(105 41.5237 20.0285)"
        fill="#718096"
      />
      <rect
        x="61.1356"
        y="36.7302"
        width="17.0608"
        height="17.0608"
        rx="2.71423"
        transform="rotate(135 61.1356 36.7302)"
        fill="#718096"
      />
    </g>
  </Icon>
);

export const VitvioLogo = (props: MergedIconProps) => {
  return (
    <Icon
      as="svg"
      width="136px"
      height="32px"
      viewBox="0 0 137 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M28.9974 9.80484L23.6772 7.54684C23.2267 7.35548 22.9295 6.90579 22.9295 6.41783V2.0549C22.9295 0.476215 21.2232 -0.509268 19.8524 0.275293L7.64955 7.25023L1.03528 11.0487C0.393022 11.4122 0 12.0915 0 12.8283V19.1813C0 19.918 0.393022 20.5973 1.03528 20.9609L7.64955 24.7498L19.8428 31.7247C21.2136 32.5093 22.9199 31.5238 22.9199 29.9451V25.5917C22.9199 25.0942 23.2171 24.6541 23.6676 24.4627L28.9878 22.1952C29.7451 21.8699 30.2339 21.1331 30.2339 20.3103V11.7088C30.2531 10.8764 29.7547 10.1301 28.9974 9.80484ZM7.30446 17.1147C6.38421 16.665 6.37463 15.3542 7.30446 14.9045L17.1971 10.0823L21.0507 8.20701C21.875 7.80516 22.824 8.40794 22.824 9.31688V22.6927C22.824 23.6016 21.8655 24.1948 21.0507 23.8026L17.1971 21.9273L7.30446 17.1147Z"
        fill={props.color ? props.color : 'CBD5E0'}
      />
      <path d="M66.3761 10.8596H70.8473V27.948H66.3761V10.8596Z" fill={props.color ? props.color : 'CBD5E0'} />
      <path
        d="M76.7229 24.1109V14.4185H73.6171V10.8596H76.7229V5.35327H81.1941V10.8596H85.1076L86.0595 14.4185H81.1941V23.353C81.1941 24.0341 81.5499 24.3795 82.1845 24.3795H85.5884V27.9384H80.6268C78.2806 27.948 76.7229 26.4419 76.7229 24.1109Z"
        fill={props.color ? props.color : 'CBD5E0'}
      />
      <path d="M110.294 10.8584H114.765V27.9468H110.294V10.8584Z" fill={props.color ? props.color : 'CBD5E0'} />
      <path
        d="M117.593 19.7265V19.1797C117.593 13.7022 121.564 10.479 126.814 10.479C132.064 10.479 136.036 13.7022 136.036 19.1797V19.7265C136.036 25.2041 132.064 28.4273 126.814 28.4273C121.564 28.4273 117.593 25.2137 117.593 19.7265ZM131.564 19.621V19.2757C131.564 16.0908 129.574 14.3066 126.814 14.3066C124.045 14.3066 122.064 16.0908 122.064 19.2757V19.621C122.064 22.8058 124.083 24.5901 126.814 24.5901C129.545 24.5901 131.564 22.8154 131.564 19.621Z"
        fill={props.color ? props.color : 'CBD5E0'}
      />
      <path d="M70.8473 3.96143H66.3761V8.43208H70.8473V3.96143Z" fill={props.color ? props.color : 'CBD5E0'} />
      <path d="M114.765 3.96143H110.294V8.43208H114.765V3.96143Z" fill={props.color ? props.color : 'CBD5E0'} />
      <path
        d="M64.2336 3.96143L58.1251 25.8503C57.8453 26.8738 56.9593 27.6647 55.8635 27.874C55.6537 27.9205 55.4439 27.9438 55.234 27.9438H50.544L50.0543 27.8973C48.9119 27.7112 47.9793 26.9203 47.6762 25.8503L41.5677 3.96143H46.6737L52.1527 24.1755H53.6253L59.1043 3.96143H64.2336Z"
        fill={props.color ? props.color : 'CBD5E0'}
      />
      <path
        d="M108.268 3.96143L102.159 25.8503C101.879 26.8738 100.993 27.6647 99.8975 27.874C99.6876 27.9205 99.4778 27.9438 99.268 27.9438H94.5779L94.0883 27.8973C92.9459 27.7112 92.0133 26.9203 91.7102 25.8503L85.6017 3.96143H90.7076L96.1866 24.1755H97.6593L103.138 3.96143H108.268Z"
        fill={props.color ? props.color : 'CBD5E0'}
      />
    </Icon>
  );
};
